/**
 * Single grade-row visualization.
 */
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect } from "react";
import PropTypes from "prop-types";

import { useAsterController } from "context";
import { asArray } from "utils/safeData";

/**
 * Renders one module's earned vs possible grade bar.
 *
 * @param {{ item: Object }} props
 */
const AnalysisGradeLine = (props) => {

  const { t } = useTranslation('common');

  const [controller] = useAsterController();
  const { themes, loadedDashboard } = controller;

  const [chartOption, setChartOption] = useState(null);

  useEffect(() => {
    const series1 = [...asArray(props.series1)];
    const series2 = [...asArray(props.series2)];
    if (series1.length && series2.length && loadedDashboard && themes.length) {

      const colorMain1 = (themes || []).find(v => v.name === 'color_main1')?.value || '#F76060';
      const colorMain3 = (themes || []).find(v => v.name === 'color_main3')?.value || '#F0BC04';

      const xAxisCats = [t('Start'), ...Array.from({ length: series2.length }, (_, i) => i + 1), t('End')];
      series1.unshift(0);
      series1.push(0);
      series2.unshift(0);
      series2.push(0);

      setChartOption({
        chart: {
          renderTo: 'container',
          backgroundColor: "rgba(0, 0, 0, 0)",
          height: '200px'
        },
        title: {
          text: ''
        },
        tooltip: {
          shared: true
        },
        xAxis: {
          categories: xAxisCats
        },
        yAxis: {
          tickInterval: 1,
          min: 0,
          max: Math.ceil(Math.max(...series2)) + 0.1
        },
        series: [{
          type: 'spline',
          name: t('Corrects'),
          color: colorMain1,
          data: series1
        }, {
          type: 'spline',
          name: t('Total'),
          color: colorMain3,
          lineWidth: 1,
          opacity: 0.5,
          data: series2
        }],
        credits: {
          enabled: false
        }
      });
    }
  }, [props.series1, props.series2, themes.length, loadedDashboard, t, themes]);

  return <div>
    {
      chartOption &&
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOption}
      />
    }
  </div>;
};

AnalysisGradeLine.propTypes = {
  series1: PropTypes.array,
  series2: PropTypes.array,
};

export default AnalysisGradeLine;